<script>
import { MapGender } from "@/common/util";
import PagenationContainer from "@/components/common/PagenationContainer.vue";
import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  data() {
    const ROLE_SUPER_ADMIN =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1;
    const ROLE_REGION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_REGION_MANAGER") > -1;
    const ROLE_AGENT_MANAGER = localStorage.getItem("roles").indexOf("ROLE_AGENT_MANAGER") > -1;
    const districtArray = [
      {
        label: "省份搜索",
        keyName: "districtProvince",
        children: []
      },
      {
        label: "",
        keyName: "districtCity",
        children: []
      }
    ];
    if (ROLE_REGION_MANAGER) {
      districtArray.push({
        label: "当年销售目标",
        keyName: "setTarget",
        value: "all",
        children: [
          {
            label: "全部",
            keyName: "all"
          },
          {
            label: "已设置",
            keyName: true
          },
          {
            label: "未设置",
            keyName: false
          }
        ]
      });
    }
    return {
      ROLE_SUPER_ADMIN,
      ROLE_REGION_MANAGER,
      ROLE_AGENT_MANAGER,
      currentPage:1,
      pageCount: 1,
      distribution: false,
      distributionRefund: false,
      ProvinceList: [],
      addMyAgent: false,
      agentGradeData:{
        options:[],
        parentId:"",
        userId:"",
        grade:''
      },
      agentChangeFlag: false,
      agentParentName: '',
      searchFormData: {
        name: "",
        staffId: "",
        phone: "",
        setTarget: "",
        provinceCity: ""
      },
      districtArray: districtArray,
      textInputArray: [
        {
          label: "公司名称",
          keyName: "companyName"
        },
        {
          label: "联系电话",
          keyName: "phone"
        }
      ],
      tableData: [],
      buttonArray: [
        {
          text: "进货",
          key: "stock"
        },
        {
          text: "退货",
          key: "reject"
        },
        {
          text: "重置密码",
          key: "reset"
        },
        {
          text: "删除",
          key: "remove"
        }
      ],
      addingUser: false,
      resetPassword: false,
      stopAgent: false,
      removeAgent: false,
      buyGoods: false,
      rejectGoods: false,
      addNewAgentArr: [
        {
          label: "公司名称",
          keyName: "companyName",
          type: "text"
        },
        {
          label: "联系人姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "联系人性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE"
            },
            {
              label: "女",
              keyName: "FEMALE"
            }
          ]
        },
        {
          label: "联系电话",
          keyName: "phone",
          type: "text"
        },
        {
          label: "疗程单价",
          keyName: "coursePrice",
          value: 1500,
          type: "price"
        },
      ],
      distributeArray: [
        {
          label: "类型",
          keyName: "distributeType",
          type: "select",
          value: 1,
          children: [{label: "疗程", keyName: 1}, {label:"单次训练", keyName: 2}]
        },
        {
          label: "数量",
          keyName: "courseCount",
          type: "number"
        },
        {
          label: "单价",
          keyName: "unitPrice",
          type: "price"
        },
        {
          label: "金额总价",
          keyName: "totalPrice",
          type: "price",
          isDisable: true
        }],
      buyGoodsArray: [
        {
          label: "类型",
          keyName: "distributeType",
          type: "select",
          value: 1,
          children: [{label: "疗程", keyName: 1}, {label:"单次训练", keyName: 2}]
        },
        {
          label: "数量",
          keyName: "courseCount",
          type: "number"
        },
        {
          label: "单价",
          keyName: "unitPrice",
          type: "price"
        },
        {
          label: "金额总价",
          keyName: "totalPrice",
          type: "price",
          isDisable: true
        },
        {
          label: "金额到账",
          keyName: "payment",
          type: "switch",
          value: true
        },
        {
          label: "备注",
          keyName: "remark",
          type: "text"
        }
        // {
        //   label: "",
        //   keyName: "alert",
        //   type: "alert",
        //   alertContent: '一个疗程60次训练，建议每天训练两次',
        // }
      ],
      rejectGoodsArray: [
      {
          label: "类型",
          keyName: "distributeType",
          type: "select",
          children: [{label: "疗程", keyName: 1}, {label:"单次训练", keyName: 2}]
        },
        {
          label: "数量",
          keyName: "courseCount",
          type: "number"
        },
        {
          label: "单价",
          keyName: "unitPrice",
          type: "price"
        },
        {
          label: "合计",
          keyName: "totalPrice",
          type: "price",
          isDisable: true
        },
        {
          label: "金额到账",
          keyName: "payment",
          type: "switch",
          value: true
        },
        {
          label: "备注",
          keyName: "remark",
          type: "text"
        }
        // {
        //   label: "",
        //   keyName: "alert",
        //   type: "alert",
        //   alertContent: '一个疗程60次训练，建议每天训练两次',
        // }
      ],
      operationGoodsAlert: "一个疗程60次训练，建议每天训练两次",
      resetPasswordArray: [
        {
          label: "手机号",
          keyName: "phone",
          type: "text",
          isDisable: true
        },
        {
          label: "本账户密码",
          keyName: "password",
          type: "password",
          placeholder: "请输入您的登录密码进行验证。"
        }
        // {
        //   label: "",
        //   keyName: "alert",
        //   type: "alert",
        //   alertContent: '系统将自动生成密码并发送到用户的手机',
        // }
      ],
      resetPasswordAlert: "系统将自动生成密码并发送到用户的手机",
      defaultValue: {},
      totalElements: 0,
      regionSearchArray: [
        // {
        //   label: "编号",
        //   keyName: "staffId",
        //   type: "text"
        // },
        {
          label: "公司名称",
          keyName: "companyName",
          type: "text"
        },
        {
          label: "联系人姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "联系电话",
          keyName: "phone",
          type: "text"
        },
        {
          label: "省市",
          keyName: "provinceCity",
          children: [],
          type: "cascader"
        },{
          label: "代理商级别",
          keyName: "grade",
          children: [
            {label: "一级", keyName: "PRIMAL"}, 
            {label: "次级", keyName: "SECONDARY"}
          ],
          type: "select"
        },
        {
          label: "当年销售目标",
          keyName: "setTarget",
          type: "select",
          value: "",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "已设置",
              keyName: true
            },
            {
              label: "未设置",
              keyName: false
            }
          ]
        }
      ],
      agentSearchArray: [
        {
          label: "公司名称",
          keyName: "companyName",
          type: "text"
        },
        {
          label: "联系人姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "联系电话",
          keyName: "phone",
          type: "text"
        },
        {
          label: "省市",
          keyName: "provinceCity",
          children: [],
          type: "cascader"
        },
        {
          label: "当年销售目标",
          keyName: "setTarget",
          type: "select",
          value: "",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "已设置",
              keyName: true
            },
            {
              label: "未设置",
              keyName: false
            }
          ]
        }
      ],
      adminSearchArray: [
        {
          label: "公司名称",
          keyName: "companyName",
          type: "text"
        },
        {
          label: "联系人姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "联系电话",
          keyName: "phone",
          type: "text"
        },
        {
          label: "省市",
          keyName: "provinceCity",
          children: [],
          type: "cascader"
        }, {
          label: "代理商级别",
          keyName: "grade",
          children: [
            {label: "一级代理", keyName: "PRIMAL"}, 
            {label: "次级代理", keyName: "SECONDARY"}
          ],
          type: "cascader"
        }
      ]
    };
  },
  computed: {
    activeSearchArray() {
      if (this.ROLE_REGION_MANAGER) {
        return this.regionSearchArray;
      } else if (this.ROLE_SUPER_ADMIN) {
        return this.adminSearchArray;
      } else {
        return this.agentSearchArray;
      }
    }
  },
  created() {
    this.loadProvice();
    this.loadData();
  },
  components: {
    PagenationContainer
  },
  methods: {
    async loadData() {
      let params = {page: this.currentPage - 1};
      for (let key in this.searchFormData) {
        if (key === "provinceCity") {
          if (this.searchFormData[key]) {
            if (this.searchFormData[key][0]) {
              params.provinceId = this.searchFormData[key][0];
            }
            if (this.searchFormData[key][1]) {
              params.districtId = this.searchFormData[key][1];
            }
          }
        } else if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }
      let data;

      const getManageRange = ranges => {
        const names = ranges.map(o => o.name);
        if (names.length > 2) {
          return `${names[0]},${names[1]}...等${names.length}个城市`;
        } else {
          return names.join(",");
        }
      };
      if (this.ROLE_SUPER_ADMIN) {
        data = await this.$http.getAgentList(params, "group");
        if (data && data.content) {
          this.totalElements = data.totalElements;

          let newTableData = [];
          data.content.forEach(item => {
            console.log("item:" + item);
            newTableData.push({
              staffId: item.user.staffId,
              name: item.user.name,
              companyName: item.companyName,
              gender: MapGender(item.user.gender),
              phone: item.user.phone,
              grade: item.grade == 'PRIMAL' ? '一级' : (item.grade == 'SECONDARY' ? '次级' : '未知'),
              parentName: item.parent ? item.parent.companyName : null,
              range: item.districts ? getManageRange(item.districts) : "--",
              remainingTreatmentCount: item.remainingTreatmentCount,
              id: item.user.id,
              singleSaleCount: item.singleSaleCount,
              enabled: item.user.enabled,
              targetNumber: `${(item.agentAchievement &&
                item.agentAchievement.actualNumber) ||
                "--"}/${(item.agentAchievement &&
                item.agentAchievement.targetNumber) ||
                "未设置"}`,
              targetPercentage:
                item.agentAchievement && item.agentAchievement.targetNumber
                  ? `${parseFloat(
                      (
                        item.agentAchievement.actualNumber /
                        item.agentAchievement.targetNumber
                      ).toFixed(2)
                    ) * 100} %`
                  : "未设置"
            });
          });
          this.tableData = newTableData;
        }
      } else if (this.ROLE_REGION_MANAGER) {
        data = await this.$http.getAgentList(params, "region");
        if (data && data.content) {
          this.totalElements = data.totalElements;

          let newTableData = [];
          data.content.forEach(item => {
            newTableData.push({
              staffId: item.user.staffId,
              name: item.user.name,
              companyName: item.companyName,
              gender: MapGender(item.user.gender),
              phone: item.user.phone,
              grade: item.grade == 'PRIMAL' ? '一级' : (item.grade == 'SECONDARY' ? '次级' : '未知'),
              parentName: item.parent ? item.parent.companyName : null,
              range: item.districts ? getManageRange(item.districts) : "--",
              remainingTreatmentCount: item.remainingTreatmentCount,
              id: item.user.id,
              singleSaleCount: item.singleSaleCount,
              enabled: item.user.enabled,
              enabled: item.user.enabled,
              targetNumber: `${(item.agentAchievement &&
                item.agentAchievement.actualNumber) ||
                "--"}/${(item.agentAchievement &&
                item.agentAchievement.targetNumber) ||
                "未设置"}`
              // item.agentAchievement && item.agentAchievement.targetNumber,
              // targetPercentage:
              //   item.agentAchievement && item.agentAchievement.targetNumber
              //     ? `${parseFloat(
              //         (
              //           item.agentAchievement.actualNumber /
              //           item.agentAchievement.targetNumber
              //         ).toFixed(2)
              //       ) * 100} %`
              //     : "未设置"
            });
          });
          this.tableData = newTableData;
        }
      } else {
        data = await this.$http.getAgentList(params, "agent");
        if (data && data.content) {
          this.totalElements = data.totalElements;

          let newTableData = [];
          data.content.forEach(item => {
            newTableData.push({
              staffId: item.user.staffId,
              name: item.user.name,
              companyName: item.companyName,
              gender: MapGender(item.user.gender),
              phone: item.user.phone,
              grade: item.grade == 'PRIMAL' ? '一级' : (item.grade == 'SECONDARY' ? '次级' : '未知'),
              parentName: item.parent ? item.parent.companyName : null,
              range: item.districts ? getManageRange(item.districts) : "--",
              remainingTreatmentCount: item.remainingTreatmentCount,
              id: item.user.id,
              enabled: item.user.enabled,
              singleSaleCount: item.singleSaleCount,
              targetNumber: `${(item.agentAchievement &&
                item.agentAchievement.actualNumber) ||
                "--"}/${(item.agentAchievement &&
                item.agentAchievement.targetNumber) ||
                "未设置"}`
              // item.agentAchievement && item.agentAchievement.targetNumber,
              // targetPercentage:
              //   item.agentAchievement && item.agentAchievement.targetNumber
              //     ? `${parseFloat(
              //         (
              //           item.agentAchievement.actualNumber /
              //           item.agentAchievement.targetNumber
              //         ).toFixed(2)
              //       ) * 100} %`
              //     : "未设置"
            });
          });
          this.tableData = newTableData;
        }
      }
      this.pageCount = data.totalPages;
    },
    onSearch(done) {
      this.loadData();
    },
    async loadProvice() {
      let ProvinceList;
      let province = [];
      if (this.ROLE_SUPER_ADMIN) {
        ProvinceList = await this.$http.getProvinceList("superAdmin");
        province = this.adminSearchArray;
      } else if (this.ROLE_REGION_MANAGER) {
        ProvinceList = await this.$http.getProvinceList("regionManager");
        province = this.regionSearchArray;
      } else {
        ProvinceList = await this.$http.getProvinceList("agent");
        province = this.regionSearchArray;
      }
      if (ProvinceList.length > 0) {
        const provinceChildren = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            value: o.id,
            children: o.sons.map(o => {
              return {
                label: o.name,
                value: o.id
              };
            }),
            id: o.id,
            name: o.name
          };
        });
        province.forEach(o => {
          if (o.keyName === "provinceCity") {
            o.children = provinceChildren;
          }
        });
        this.ProvinceList = provinceChildren;
      }
    },
    onSearchChange(data) {
      forOwn(data, (value, key) => {
        this.searchFormData[key] = data[key];
      });
    },
    async onAddAgent(form) {
      const updateData = {
        name: form.name,
        phone: form.phone,
        gender: form.gender,
        companyName: form.companyName,
        coursePrice: form.coursePrice,
        grade: 'PRIMAL' 
      };
      let result = await this.$http.AddNewAgent(updateData);
      if (result === "success") {
        this.loadData();
      }
    },
    async onAddMyAgent(form) {
      const updateData = {
        name: form.name,
        phone: form.phone,
        gender: form.gender,
        companyName: form.companyName,
        coursePrice: form.coursePrice,
        grade: 'SECONDARY' 
      };
      let result = await this.$http.AddMyAgent(updateData);
      if (result === "success") {
        this.loadData();
      }
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      switch (key) {
        case "stock":
          this.buyGoods = true;
          break;
        case "reject":
          this.rejectGoods = true;
          break;
        case "reset":
          this.resetPassword = true;
          break;
        case "stop":
          this.stopAgent = true;
          break;
        case "remove":
          this.removeAgent = true;
          break;
        case "agentUpgrade":
          this.$confirm('确认要升级为一级代理商吗?', '代理商升级', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.agentGradeData.grade = 'PRIMAL';
            this.agentGradeData.userId = row.id;
            this.agentGradeData.parentId = '';
            this.updateAgentGrade()
          }).catch((e) => {
            console.log(e)
            this.$message({
              type: 'info',
              message: '已取消升级'
            });
          });
          break;
        case "agentDemotion":
          this.$confirm('确认要降级为次级代理商吗?', '代理商降级', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              this.agentChangeFlag = true;
              this.agentGradeData.userId = row.id;
              this.agentParentName = row.parentName;
            }).catch((e) => {
              this.$message({
                type: 'info',
                message: '已取消降级'
              })
            });
            break;
        case "agentParentUpdate":
          this.agentChangeFlag = true;
          this.agentGradeData.userId = row.id;
          this.agentParentName = row.parentName;
          break;
      }
    },
    async onUpdateAgentGrade() {
      this.agentGradeData.grade = 'SECONDARY';
      this.updateAgentGrade();
    },
    async updateAgentGrade() {
      this.agentGradeData.options = null;
      let result = await this.$http.regionUpdateAgentGrade(this.agentGradeData);
      if (result == 'success') {
        this.agentChangeFlag = false;
        this.loadData();
      }
    },
    onClickCancel(key, afterSubmit) {
      this.defaultValue = {};
      switch (key) {
        case "buyGoods":
          this.buyGoods = false;
          break;
        case "distributeAgent":
          this.distribution = false;
          break;
        case "distributionRefund":
          this.distributionRefund = false;
          break;
        case "rejectGoods":
          this.rejectGoods = false;
          break;
        case "resetAccount":
          if (afterSubmit !== "afterSubmit") {
            this.resetPassword = false;
          }
          // this.resetPassword = false;
          break;
        case "stopAccount":
          this.stopAgent = false;
          break;
        case "deleteAccount":
          this.removeAgent = false;
          break;
      }
    },
    async onChangeEnabled(userId, enabled) {
      const updateData = {
          userId: userId,
          enabled: enabled
        };
        let result = await this.$http.regionUpdateAgentInfo('updateEnabled', updateData);
        this.loadData();
      this.defaultValue = {};
    },
    async upgradeAgent(row) {
      console.log("升级....");
    },
    getBtnArrays(item) {
      let btn = [];
      this.buttonArray.forEach(b => btn.push(b));
        if (item.grade =='一级') {
          btn.push({
            text: "降级",
            key: "agentDemotion"
          });
        } else {
          btn.push({
            text: "升级",
            key: "agentUpgrade"
          });
          btn.push({
            text: "上级代理调整",
            key: "agentParentUpdate"
          })
        }
      return btn;
    },
    async onUpdateAccount(formdata, type, row) {
      console.log("formdata");
      console.log(formdata);
      if (type === "resetAccount") {
        const pwd = formdata.password;
        let result = await this.$http.checkAdminPwd(pwd);
        if (result == "success") {
          const updateData = {
            userId: row.id,
            resetPassword: true
          };
          let result = await this.$http.regionUpdateAgentInfo(type, updateData);
          if (result) {
            this.$message.success("重置成功");
            this.resetPassword = false;
          }
        } else {
          this.$message.warning("密码错误，请重新输入密码");
        }
      } else if (type === "stopAccount") {
        const updateData = {
          userId: row.id,
          enabled: false
        };
        let result = await this.$http.regionUpdateAgentInfo(type, updateData);
      } else if (type === "deleteAccount") {
        let result = await this.$http.regionUpdateAgentInfo(type, row.id);
      } else if (type === "buyGoods") {
        const updateData = {
          agentId: row.id,
          courseCount: formdata.courseCount,
          unitPrice: formdata.unitPrice,
          payment: formdata.payment,
          distributeType: formdata.distributeType,
          remark: formdata.remark
        };
        console.log("buyGoods");
        let result = await this.$http.regionUpdateAgentInfo(type, updateData);
      } else if (type === "rejectGoods") {
        const updateData = {
          agentId: row.id,
          courseCount: formdata.courseCount,
          unitPrice: formdata.unitPrice,
          payment: formdata.payment,
          distributeType: formdata.distributeType,
          remark: formdata.remark
        };
        let result = await this.$http.regionUpdateAgentInfo(type, updateData);
      } else if (type === "distributeAgent") {
        const updateData = {
          userId: this.defaultValue.id,
          quantity: formdata.courseCount,
          unitPrice: formdata.unitPrice,
          operateType: 'PAY',
          saleFlag: true,
          distributeType: formdata.distributeType,
          remark: formdata.remark
        }
        await this.$http.distributeAgent(updateData)
        this.distribution = false;
      } else if (type === "distributionRefund") {
        const updateData = {
          userId: this.defaultValue.id,
          quantity: formdata.courseCount,
          unitPrice: formdata.unitPrice,
          operateType: 'REFUND',
          saleFlag: true,
          distributeType: formdata.distributeType,
          remark: formdata.remark
        }
        await this.$http.distributeAgent(updateData)
        this.distributionRefund = false;
      }
      this.loadData();
      this.defaultValue = {};
    },
    onClick(row) {
      this.$router.push({
        path: `${this.$route.path}/agentDetail/${row.id}`
      });
    },
    async queryPrimalAgent(query) {
      this.queryAgentByGrade('PRIMAL', query);
    },
    async queryAgentByGrade(grade, query) {
      this.agentGradeData.options = await this.$http.findAgentByGrade({grade: grade, search: query})
    },
    handleAgentDialogClose() {
      this.agentChangeFlag = false;
      this.agentGradeData.options = [];
      this.agentGradeData.grade='';
      this.agentGradeData.parentId='';
      this.agentGradeData.userId='';
      this.agentParentName = '';
    }, handleCurrentChange(val) {
      if(!val) val = 1;
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.loadData();
    }
  }
};
</script>
<template>
  <div class="agentIndex">
    <DialogForm
      v-if="addingUser"
      formTitle="添加代理商"
      :formInputArray="addNewAgentArr"
      @close="addingUser = false"
      @submitForm="onAddAgent"
      keyOperation="addAccount"
    />
    <DialogForm
      v-if="addMyAgent"
      formTitle="添加分销商"
      :formInputArray="addNewAgentArr"
      @close="addMyAgent = false"
      @submitForm="onAddMyAgent"
      keyOperation="addMyAccount"
    />
    <DialogForm
      v-if="distribution"
      formTitle="分销供货"
      :formInputArray="distributeArray"
      :defaultValue="defaultValue"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="distributeAgent"
      :alertItem="operationGoodsAlert"
    />
    <DialogForm
      v-if="distributionRefund"
      formTitle="分销退货"
      :formInputArray="distributeArray"
      :defaultValue="defaultValue"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="distributionRefund"
      :alertItem="operationGoodsAlert"
    />
    <DialogForm
      v-if="buyGoods"
      formTitle="进货"
      :formInputArray="buyGoodsArray"
      :defaultValue="defaultValue"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="buyGoods"
      :alertItem="operationGoodsAlert"
    />
    <DialogForm
      v-if="rejectGoods"
      formTitle="退货"
      :formInputArray="rejectGoodsArray"
      :defaultValue="defaultValue"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="rejectGoods"
      :alertItem="operationGoodsAlert"
    />
    <DialogForm
      v-if="resetPassword"
      formTitle="重置密码"
      :defaultValue="defaultValue"
      :formInputArray="resetPasswordArray"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="resetAccount"
      :alertItem="resetPasswordAlert"
    />
    <DialogForm
      v-if="stopAgent"
      :defaultValue="defaultValue"
      formTitle="请确认停用账号"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="stopAccount"
      confirmButton="确认"
    />
    <DialogForm
      v-if="removeAgent"
      :defaultValue="defaultValue"
      formTitle="请确认删除账号"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="deleteAccount"
      confirmButton="确认"
    />
    <el-dialog
      title="代理商调整"
      :visible.sync="agentChangeFlag"
      width="30%"
      :before-close="handleAgentDialogClose">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="原代理:" v-if="agentParentName!='' && agentParentName!=null">
          {{ agentParentName }}
        </el-form-item>
      <el-form-item label="一级代理:">
        <el-select
          v-model="agentGradeData.parentId"
          filterable
          remote
          reserve-keyword
          placeholder="请输入上级代理商"
          :remote-method="queryPrimalAgent"
          >
          <el-option
            v-for="item in agentGradeData.options"
            :key="item.userId"
            :label="item.name"
            :value="item.userId">
          </el-option>
        </el-select>  
      </el-form-item></el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agentChangeFlag = false">取 消</el-button>
        <el-button type="primary" @click="onUpdateAgentGrade">确 定</el-button>
      </span>
    </el-dialog>

    <!-- <searchForm class="searchForm" :textInputArray="textInputArray" @onChange="onSearchChange" />
    <searchForm
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      :selectInputArray="districtArray"
      @onChange="onSearchChange"
    />-->
    <searchFormNew
      :class="ROLE_REGION_MANAGER ? 'searchFormRegin' : 'searchFormAdmin'"
      showSearch
      @onSearch="onSearch"
      @onChange="onSearchChange"
      :searchItemArray="activeSearchArray"
    />
    <elementButton
      class="AddAgentButton"
      v-if="ROLE_REGION_MANAGER"
      @click="addingUser = true"
      size="medium"
      type="primary"
    >添加代理商</elementButton>

    <elementButton
      class="AddAgentButton"
      v-if="ROLE_AGENT_MANAGER"
      @click="addMyAgent = true"
      size="medium"
      type="primary"
    >添加分销商</elementButton>

    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      @row-click="onClick"
      class="agentTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="companyName" align="left" label="公司名称" min-width="115"></el-table-column>
      <el-table-column prop="name" align="left" label="联系人" min-width="95"></el-table-column>
      <el-table-column prop="gender" align="left" label="性别" width="60"></el-table-column>
      <el-table-column prop="phone" align="left" label="联系电话" width="120"></el-table-column>
      <el-table-column prop="range" align="left" label="管理区域" min-width="130"></el-table-column>
      <el-table-column prop="grade" align="left" label="代理商级别" min-width="95"></el-table-column>
      <el-table-column prop="remainingTreatmentCount" align="left" label="剩余疗程" width="95"></el-table-column>
      <el-table-column prop="singleSaleCount" align="left" label="剩余单次训练额度" width="95"></el-table-column>
      <el-table-column prop="targetNumber" align="left" label="年度目标" width="95"></el-table-column>
      <el-table-column prop="enabled" align="left" label="状态" width="95">
        <template slot-scope="scope">
          <el-switch
            v-if="ROLE_REGION_MANAGER || ROLE_AGENT_MANAGER"
            v-model="scope.row.enabled" 
            :active-value="true"
            :inactive-value="false"
            @click.native.stop="return false"
            @change = "onChangeEnabled(scope.row.id, scope.row.enabled)" />
          <span v-if="!ROLE_REGION_MANAGER && !ROLE_AGENT_MANAGER">{{ scope.row.enabled ? '启用' : '未启用' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="targetPercentage" align="left" label="目标完成度" width="95"></el-table-column> -->
      <el-table-column
        v-if="ROLE_REGION_MANAGER"
        prop="operation"
        align="left"
        min-width="290"
        label="操作"
      >
        <template slot-scope="scope">
          <textButtonGroup
            :buttonArray="getBtnArrays(scope.row)"
            :rowData="scope.row"
            @onOperationClick="onOperationClick"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="!ROLE_REGION_MANAGER && !ROLE_SUPER_ADMIN && ROLE_AGENT_MANAGER"
        prop="operation"
        align="left"
        min-width="290"
        label="操作"
      >
      <template slot-scope="scope">
        <span class="textButton">
          <el-button type="text" size="small" @click.stop="distribution = true; defaultValue = scope.row">供货</el-button>
          <el-button type="text" size="small" @click.stop="distributionRefund = true; defaultValue = scope.row">退货</el-button>
        </span>
      </template>
    </el-table-column>
    </el-table>
    <PagenationContainer >
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.agentIndex {
  .searchFormAdmin {
    margin: 0 1%;
    padding-top: 15px;
  }
  .searchFormRegin {
    width: 900px;
    margin: 0 1%;
    padding-top: 15px;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .AddAgentButton {
    // margin: 21px 5px;
    width: 100px;
    border: 1px;
    margin-left: 1%;
    margin-top: 5px;
    margin-bottom: 10px;
    border-radius: 3px;
    float: left;
    padding: 10px;
  }

  .agentTable {
    margin: 10px auto;
    border: 1px;
    width: 98%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Agent/index.vue